<div class="not-found-container">
  <ng-lottie
    [options]="options"
    class="lottie-bg"
  ></ng-lottie>
  <app-button
    label="Volver a inicio"
    (onClick)="handleGoBack()"
    class="return-button"
  ></app-button>
</div>